import { useEffect, useRef } from "react";
import translate from "../locales";
import Markdown from "react-markdown";
import introImage from "../assets/images/intro.gif";

export default function IntroDialog() {
  const elementRef = useRef();

  useEffect(() => elementRef.current?.showModal(), [elementRef]);

  return (
    <dialog className="intro" ref={elementRef}>
      <div className="intro__content">
        <h2 className="intro__title">{translate("intro.title")}</h2>
        <Markdown className="intro__body">{translate("intro.body")}</Markdown>
        <img src={introImage} alt="" className="intro__image" />
        <button
          className="intro__button button"
          onClick={() => elementRef.current.close()}
        >
          {translate("intro.button")}
        </button>
      </div>
    </dialog>
  );
}
